import { action } from 'satcheljs/lib/legacy';
import FilePickerViewState from '../store/schema/FilePickerViewState';

export default action('clearFilePickerBreadcrumb')(function clearFilePickerBreadcrumb(
    viewState: FilePickerViewState
) {
    viewState.breadcrumbs = [];
});
